import angular from 'angular';

angular.module('folkeuni').factory('MediaApi', function($http) {
  var self = this;
  var apiBase = '/api/umbraco/media';

  self.getImage = function(mediaId) {
      return $http({
        method: 'get',
        url: apiBase + '/' + mediaId
      });
  }

  self.searchMedia = function(searchObj){
    return $http({
      method: 'post',      
      data: searchObj,
      url: apiBase + '/search'
    });
  }
  
  return self;
});
